import { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { ContentLayoutProps } from '..';
import { store } from '../../store/store';
import { FormText, Title2 } from '../../styles/TypoStyle';
import { ResponseModel, ResponsePageType, signatureByName } from '../../utils/ResponsePageModel';
import creditoResponse from '../assets/creditoResponse.svg';
import { FooterContainer } from '../FooterContainer';

const GenericContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: visible;
  margin: 24px 16px 0px 16px;
  padding-bottom: 32px;

  base-button {
    --light-white: var(--colors-on-primary);
    --green-50: var(--colors-primary-variant-light);
    --green-500: var(--colors-primary-default);
    --green-800: var(--colors-primary-variant-dark);
    font-family: var(--typo-form-font-family);
    font-size: var(--typo-form-font-size);
    letter-spacing: var(--typo-form-letter-spacing);
    line-height: var(--typo-form-line-height);
    font-weight: bold;
    --padding-button: 11px 0px;
  }
`;

const HeaderTtile = styled.div`
  display: flex;
  flex-direction: row;
`;
const HeaderDetails = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  white-space: pre-line;
`;

const HeaderContainer = styled.div`
  flex: 1;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CreditoContainer = styled.div`
  display: inline-flex;
  margin-right: 11px;
  img {
    width: 66px;
    height: 88px;
  }

  //tablet or larger
  @media (min-width: 496px) {
    img {
      width: 88px;
      height: 128px;
    }
  }
`;

const HeaderTitleContainer = styled(Title2)`
  padding: 11px 0px 11px 0px;
  white-space: pre-line;

  //tablet or larger
  @media (min-width: 496px) {
    padding: 24px 0px 24px 0px;
    font-size: var(--typo-title1-font-size);
    line-height: var(--typo-title1-line-height);
  }
`;

const Title5 = styled(FormText)`
  font-weight: var(--typo-title4-font-weight);
`;

const HeaderDetailsTitleContainer = styled.div`
  margin-bottom: 8px;
`;

export const ResponseLayout: React.FunctionComponent<ContentLayoutProps> = ({ content }) => {
  const {
    state: { responseInfo },
  } = useContext(store);

  const [responseModel, setResponseModel] = useState<ResponseModel>();

  useEffect(() => {
    if (responseInfo) {
      setResponseModel(signatureByName(responseInfo?.responsePageType));
    }
  }, [responseInfo]);

  return (
    <GenericContainer>
      {responseInfo && (
        <HeaderContainer>
          <HeaderTtile>
            <CreditoContainer slot="logo">
              <img src={creditoResponse} />
            </CreditoContainer>
            <HeaderTitleContainer>{responseModel?.title}</HeaderTitleContainer>
          </HeaderTtile>
          <HeaderDetails>
            <HeaderDetailsTitleContainer>
              <Title5>{responseModel?.subTitle}</Title5>
            </HeaderDetailsTitleContainer>
            <FormText>
              {responseModel?.details}
              <Title5>{responseModel?.importantDetails}</Title5>
            </FormText>
          </HeaderDetails>
        </HeaderContainer>
      )}
      <ContentContainer>{content}</ContentContainer>
      <FooterContainer
        displayResponsePageCaption={
          responseModel?.name === ResponsePageType.IMMO ||
          responseModel?.name === ResponsePageType.CONSO ||
          responseModel?.name === ResponsePageType.NONE
        }
      />
    </GenericContainer>
  );
};
